module.exports = __webpack_public_path__ + "img/category_form.9ebef4f2.png";